import Vue from 'vue'
import App from './App.vue'
import axios from "axios";
import Router from './routes'

new Vue({
    el: '#electronicForms',

    router: Router,
	
	template: '<router-view></router-view>'
})



// WEBPACK FOOTER //
// ./ClientApp/ElectronicForms/main.js